
document.addEventListener('DOMContentLoaded', () => {

    setTimeout(() => {
        scrollToHash();
    }, 2000);

    // window.addEventListener('resize', refreshOnResize);

    // function refreshOnResize() {
    //     window.location.reload();
    // }



    let steps = document.querySelectorAll(".steps-wrapper .step-item");

    if(steps.length > 0){
        // Set initial state for all steps
        gsap.set(steps, { opacity: 0, y: 500 });
        gsap.set(steps[0], { opacity: 1, y: 0 });
    
        // Create a ScrollTrigger for pinning the section and controlling the timeline
        let mainScrollTrigger = ScrollTrigger.create({
            trigger: ".steps-section",
            start: "top top",
            end: () => "+=" + (steps.length * window.innerHeight),
            pin: true,
            scrub: 0.5, // Adjusted scrub value for faster scrolling
            
            onEnter: () => {
                gsap.to(".steps-section", { duration: 0.5, autoAlpha: 0 });
                // console.log("User has entered the .steps-section");
            },
            onEnterBack: () => {
                // console.log("User has re-entered the .steps-section from below");
            },
            onLeave: () => {
                // console.log("User has left the .steps-section going forward");
            },
            onLeaveBack: () => {
                gsap.to(".steps-section", { duration: 0.5, autoAlpha: 1 });
                // console.log("User has left the .steps-section going backward");
            }
        });
    
        // Timeline for animating steps
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".steps-section",
                start: "top top",
                end: () => "+=" + (steps.length * window.innerHeight),
                scrub: 0.5, // Adjusted scrub value for faster scrolling
            }
        });
    
        steps.forEach((step, index) => {
            if (index > 0) {
                timeline
                    .to(steps[index - 1], { opacity: 0, y: -500, duration: 0.5, ease: "power2.inOut" })
                    .to(step, { opacity: 1, y: 0, duration: 0.5, ease: "power2.inOut" }, "-=0.3");
            }
        });
    
        // Final step animation to ensure the last step is visible
        timeline.to(steps[steps.length - 1], { opacity: 1, y: 0, duration: 0.5, ease: "power2.inOut" });

    }      
    
    
    function scrollToHash() {
        let hash = window.location.hash;

        if (hash) {
            let element = document.querySelector(hash);
            if (element) {
                // Scroll to the element smoothly using gsap
                gsap.to(window, {
                    scrollTo: { y: element, offsetY: 0 }, // Adjust offsetY if necessary
                    duration: 0.1 // Duration of the scroll animation
                });
            }
        }
    }

    let backToTopButton = document.querySelector('#back_to_top');

    if(backToTopButton){
        backToTopButton.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, {
                scrollTo: 0,
                duration: 0.2
            });
        });
    }
    


    AOS.init({
        duration: 500,
        easing: 'ease-in-out',
        once: true,
        // mirror: false,
        offset: -100,
    });
});
